export default __webpack_public_path__ + "static/media/b_wdt_c_4.a6d07b1c.mp3";